
import { LogOut } from "lucide-react";
import { logout } from "@/lib/logout";

export function LogoutButton() {
  return (
    <button
      type="button"
      onClick={() => void logout()}
      aria-label="Log out"
      className="flex size-9 items-center justify-center rounded-full text-muted-foreground transition-colors active:bg-muted"
    >
      <LogOut className="size-4" />
    </button>
  );
}
